import { useState, useCallback, createContext } from "react";
import { apiBaseurl } from "../utils/ApiBaseurl";

export const EsopContext = createContext();

export const EsopProvider = ({ children }) => {
  const [accordions, setAccordions] = useState([]);
  const getAllAccordions = useCallback(async () => {
    try {
      const response = await fetch(`${apiBaseurl}backend/api/accordions`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${
            JSON.parse(localStorage.getItem("authTokens")).access
          }`,
          "Content-Type": "application/json",
        },
      });

      const _accordions = await response.json();
      setAccordions(_accordions);
    } catch (error) {
      console.error("Failed to fetch accordions:", error);
    }
  }, []);

  return (
    <EsopContext.Provider value={{ accordions, getAllAccordions }}>
      {children}
    </EsopContext.Provider>
  );
};
